import useSWR from 'swr';

import { GET_MERCHANT_APPLICATION_STATUS_API_URL } from 'tools/urls/payment';

import { getPaymentAPIResponses } from 'pages/users/user/payments/fetcher-utils';
import {
  MerchantApplicationStatus,
  type MerchantApplicationStatusResponse,
} from 'types/payment';

const POLLING_STATUSES: ReadonlyArray<MerchantApplicationStatus> = [
  MerchantApplicationStatus.Processing,
  MerchantApplicationStatus.Submitted,
];
export const MERCHANT_STATUS_POLL_INTERVAL_MS = 20000;

interface ApplicationStatusEnvelope {
  data: MerchantApplicationStatusResponse;
}

const isPollingStatus = (status?: MerchantApplicationStatus) =>
  status !== undefined && POLLING_STATUSES.includes(status);

const useMerchantApplicationStatus = (schoolID: string) => {
  const key = schoolID
    ? GET_MERCHANT_APPLICATION_STATUS_API_URL.replace('{schoolID}', schoolID)
    : null;

  const swr = useSWR<ApplicationStatusEnvelope>(key, getPaymentAPIResponses, {
    refreshInterval: (latest) =>
      isPollingStatus(latest?.data?.status)
        ? MERCHANT_STATUS_POLL_INTERVAL_MS
        : 0,
  });

  const data = swr.data?.data;
  return {
    data,
    error: swr.error,
    isLoading: !swr.error && swr.data === undefined && key !== null,
    isValidating: swr.isValidating,
    mutate: swr.mutate,
    url: key,
  };
};

export default useMerchantApplicationStatus;
